import AlertIcon from '@/assets/icons/alert.svg?react';
import GithubIcon from '@/assets/icons/github.svg?react';
import GoogleIcon from '@/assets/icons/google.svg?react';
import type { OAuthProvider } from '@/shared/config/routes';
import { BadgeIcon } from '@/shared/ui/badge-icon';
import { Button } from '@/shared/ui/button';

type OAuthFailedViewProps = {
  provider: OAuthProvider;
  providerName: string;
  onRetry: (provider: OAuthProvider) => void;
  onUseEmail: () => void;
};

export function OAuthFailedView({
  provider,
  providerName,
  onRetry,
  onUseEmail,
}: OAuthFailedViewProps) {
  const isGoogle = provider === 'google';
  return (
    <>
      <span data-enter="">
        <BadgeIcon tone="bad">
          <AlertIcon className="size-5.5" />
        </BadgeIcon>
      </span>
      <div data-enter="" className="flex flex-col gap-2" role="alert">
        <h1 className="font-semibold text-title-lg">{providerName} sign-in did not finish</h1>
        <p className="text-muted">
          The window was closed, or access was declined. Nothing was created, and you can try again.
        </p>
      </div>
      <div data-enter="" className="flex flex-col gap-2.5">
        <Button
          variant={isGoogle ? 'google' : 'default'}
          size="lg"
          isBlock
          onClick={() => onRetry(provider)}
        >
          {isGoogle ? (
            <GoogleIcon className="size-4.5 shrink-0" />
          ) : (
            <GithubIcon className="size-4.5 shrink-0" />
          )}
          Try {providerName} again
        </Button>
        <Button size="lg" isBlock onClick={onUseEmail}>
          Use email instead
        </Button>
      </div>
    </>
  );
}
